import { Reveal, MaskWords } from "./Reveal";
import BriefingForm from "./BriefingForm";

export default function ChapterEncomendas() {
  return (
    <section
      id="encomendas"
      className="relative py-32 md:py-56 border-t border-[var(--line)]"
      data-testid="chapter-encomendas"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-center gap-6 mb-14 md:mb-20">
            <span className="font-mono-tech text-[11px] text-[var(--accent)]">
              Capítulo 04
            </span>
            <span className="w-24 h-px bg-[var(--line-2)]" />
            <span className="font-mono-tech text-[11px] text-[var(--ink-2)]">
              Sua encomenda
            </span>
          </div>
        </Reveal>

        <h2 className="font-serif-display text-6xl md:text-[11vw] leading-[0.86] tracking-[-0.04em] max-w-[18ch]">
          <MaskWords text="Transforme" />
          <br />
          <span className="italic text-[var(--ink-2)]">
            <MaskWords text="sua ideia" delay={0.1} />
          </span>{" "}
          <MaskWords text="em memória." delay={0.2} />
        </h2>

        <div className="mt-16 md:mt-24 grid grid-cols-12 gap-8 md:gap-10 items-start">
          <div className="col-span-12 md:col-span-5">
            <Reveal>
              <p className="font-sans text-lg md:text-xl leading-[1.65] text-[var(--ink-2)] max-w-[42ch]">
                Nos conta a história por trás da peça — o momento, a pessoa, o
                sentimento. A gente cuida do resto, do desenho à entrega, com
                todo carinho e atenção.
              </p>
            </Reveal>

            <Reveal delay={0.15}>
              <ul className="mt-10 md:mt-14 font-mono-tech text-[11px] text-[var(--ink-2)] divide-y divide-[var(--line)] border-y border-[var(--line)]">
                {[
                  ["01", "Envie o briefing", "Aqui do lado →"],
                  ["02", "Retornamos com proposta", "Até 48h"],
                  ["03", "Modelagem + aprovação", "5 a 10 dias"],
                  ["04", "Impressão + entrega", "5 a 15 dias"],
                ].map(([n, l, t]) => (
                  <li key={n} className="flex items-center py-5 group">
                    <span className="w-8 text-[var(--accent)]">{n}</span>
                    <span className="flex-1 text-[var(--ink)] group-hover:text-[var(--accent)] transition-colors duration-500">
                      {l}
                    </span>
                    <span className="text-[var(--ink-3)]">{t}</span>
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={0.25}>
              <div className="mt-10 flex flex-col sm:flex-row gap-3">
                <a
                  href="https://wa.me/5511942681399?text=Ol%C3%A1%20Acervo%203D%2C%20quero%20uma%20pe%C3%A7a%20personalizada"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="group inline-flex items-center justify-center gap-3 border border-[var(--line-2)] hover:border-[var(--accent)] hover:text-[var(--accent)] text-[var(--ink)] font-mono-tech text-[11px] px-5 py-3 transition-colors duration-300"
                  data-testid="cta-whatsapp-alt"
                >
                  <span>Prefere WhatsApp?</span>
                  <span className="inline-block w-6 h-px bg-current group-hover:w-10 transition-[width] duration-500" />
                </a>
                <a
                  href="https://www.instagram.com/acervo_3d/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="group inline-flex items-center justify-center gap-3 border border-[var(--line-2)] hover:border-[var(--ink)] text-[var(--ink)] font-mono-tech text-[11px] px-5 py-3 transition-colors duration-300"
                  data-testid="cta-instagram-alt"
                >
                  <span>Instagram</span>
                  <span className="inline-block w-6 h-px bg-current group-hover:w-10 transition-[width] duration-500" />
                </a>
              </div>
            </Reveal>
          </div>

          <div className="col-span-12 md:col-span-7 md:pl-6">
            <Reveal delay={0.1}>
              <BriefingForm />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
